import { sortsDisplayText } from "../dataUtilities/sortsDisplayText";
import motivationalToArray from "./motivationalToArray";

const uploadJapaneseData = () => {
  const data = [
    [
      "res-1",
      5,
      -3,
      -3,
      1,
      2,
      4,
      -5,
      -5,
      -4,
      2,
      -5,
      -1,
      4,
      -2,
      -3,
      0,
      4,
      3,
      -2,
      1,
      -4,
      0,
      -1,
      0,
      -2,
      4,
      3,
      3,
      3,
      -3,
      -1,
      1,
      5,
      3,
      4,
      0,
      -1,
      2,
      1,
      0,
      -1,
      2,
      2,
      -4,
      1,
      1,
      1,
      -2,
      5,
      0,
      -4,
      -1,
      -1,
      0,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-2",
      5,
      -3,
      -3,
      1,
      2,
      4,
      -5,
      -5,
      -4,
      2,
      -5,
      -1,
      -2,
      -2,
      5,
      -1,
      0,
      0,
      1,
      1,
      4,
      4,
      1,
      -1,
      -3,
      4,
      3,
      -2,
      2,
      4,
      -4,
      3,
      -4,
      -1,
      1,
      3,
      -3,
      -2,
      0,
      0,
      3,
      1,
      2,
      1,
      -1,
      2,
      3,
      0,
      5,
      0,
      -4,
      -1,
      -1,
      0,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-3",
      5,
      -3,
      -3,
      1,
      2,
      4,
      -5,
      -5,
      -4,
      2,
      -5,
      -1,
      -2,
      -2,
      5,
      -1,
      0,
      1,
      0,
      1,
      4,
      1,
      -1,
      -3,
      4,
      4,
      3,
      -2,
      2,
      4,
      -4,
      3,
      -4,
      -1,
      1,
      3,
      -3,
      -2,
      0,
      0,
      3,
      1,
      2,
      1,
      -1,
      2,
      3,
      0,
      5,
      0,
      -4,
      -1,
      -1,
      0,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-4",
      5,
      -3,
      -3,
      1,
      2,
      4,
      -5,
      -5,
      -4,
      2,
      -5,
      -1,
      -2,
      -2,
      5,
      -1,
      0,
      0,
      1,
      1,
      4,
      1,
      -1,
      -3,
      4,
      4,
      3,
      -2,
      2,
      4,
      -4,
      3,
      -4,
      -1,
      1,
      3,
      -3,
      -2,
      0,
      0,
      3,
      1,
      2,
      1,
      -1,
      2,
      3,
      0,
      5,
      0,
      -4,
      -1,
      -1,
      0,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-5",
      5,
      -3,
      -3,
      1,
      2,
      4,
      0,
      4,
      1,
      -5,
      1,
      -1,
      0,
      -1,
      -3,
      -4,
      4,
      -5,
      3,
      2,
      -3,
      0,
      -4,
      -4,
      4,
      3,
      1,
      -2,
      3,
      -2,
      -1,
      2,
      1,
      -2,
      1,
      1,
      2,
      3,
      -1,
      5,
      -5,
      0,
      -1,
      -2,
      2,
      4,
      3,
      0,
      5,
      0,
      -4,
      -1,
      -1,
      0,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-6",
      5,
      -3,
      -3,
      1,
      2,
      1,
      4,
      -3,
      -5,
      -4,
      -1,
      -1,
      -4,
      -5,
      0,
      2,
      4,
      1,
      -3,
      5,
      -2,
      0,
      0,
      3,
      1,
      -1,
      -1,
      -2,
      4,
      0,
      1,
      1,
      3,
      4,
      2,
      2,
      -4,
      3,
      -5,
      4,
      -2,
      3,
      -2,
      1,
      -1,
      2,
      3,
      0,
      5,
      0,
      -4,
      -1,
      -1,
      0,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-7",
      5,
      -3,
      -3,
      1,
      2,
      4,
      -5,
      -5,
      -4,
      2,
      -5,
      -1,
      -2,
      -2,
      5,
      -1,
      0,
      0,
      1,
      3,
      1,
      0,
      -3,
      3,
      0,
      -1,
      3,
      3,
      -4,
      4,
      -2,
      4,
      -2,
      1,
      4,
      4,
      -3,
      -1,
      2,
      1,
      -4,
      1,
      2,
      1,
      -1,
      2,
      3,
      0,
      5,
      0,
      -4,
      -1,
      -1,
      0,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-8",
      5,
      -3,
      -3,
      1,
      2,
      4,
      -5,
      -5,
      -4,
      2,
      -5,
      -1,
      -2,
      2,
      4,
      4,
      1,
      3,
      1,
      -2,
      1,
      0,
      0,
      1,
      3,
      3,
      -1,
      -3,
      1,
      4,
      0,
      -3,
      -4,
      -1,
      5,
      2,
      3,
      -2,
      -1,
      1,
      4,
      -4,
      -2,
      0,
      -1,
      2,
      3,
      0,
      5,
      0,
      -4,
      -1,
      -1,
      0,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-9",
      5,
      -3,
      -3,
      -4,
      4,
      -5,
      4,
      -1,
      4,
      -3,
      -5,
      5,
      0,
      -1,
      4,
      1,
      1,
      -5,
      3,
      3,
      -2,
      -1,
      0,
      2,
      4,
      -4,
      2,
      2,
      1,
      1,
      -2,
      -2,
      -4,
      -1,
      1,
      3,
      -3,
      -2,
      0,
      0,
      3,
      1,
      2,
      1,
      -1,
      2,
      3,
      0,
      5,
      0,
      -4,
      -1,
      -1,
      0,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-10",
      5,
      -3,
      -3,
      1,
      2,
      4,
      -5,
      -5,
      -4,
      2,
      -5,
      -1,
      -2,
      -2,
      3,
      4,
      1,
      4,
      -1,
      -1,
      1,
      3,
      0,
      -1,
      3,
      -3,
      3,
      0,
      -4,
      1,
      4,
      4,
      -4,
      -3,
      -2,
      0,
      -2,
      0,
      5,
      1,
      2,
      1,
      2,
      1,
      -1,
      2,
      3,
      0,
      5,
      0,
      -4,
      -1,
      -1,
      0,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-11",
      5,
      -3,
      -3,
      1,
      2,
      4,
      -5,
      0,
      -1,
      0,
      0,
      -2,
      4,
      4,
      -3,
      -2,
      3,
      1,
      2,
      -4,
      -4,
      3,
      1,
      1,
      -1,
      -3,
      3,
      -2,
      4,
      2,
      -1,
      3,
      -1,
      2,
      -5,
      -4,
      1,
      0,
      1,
      5,
      -2,
      -5,
      4,
      1,
      -1,
      2,
      3,
      0,
      5,
      0,
      -4,
      -1,
      -1,
      0,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-12",
      5,
      -3,
      4,
      0,
      3,
      2,
      -4,
      -1,
      0,
      -4,
      0,
      1,
      -3,
      -5,
      0,
      -1,
      -4,
      1,
      1,
      -2,
      3,
      -5,
      0,
      -2,
      2,
      2,
      3,
      3,
      -5,
      4,
      4,
      1,
      -2,
      -1,
      -1,
      -1,
      1,
      0,
      -3,
      -2,
      1,
      -1,
      5,
      0,
      -1,
      4,
      5,
      1,
      2,
      -3,
      2,
      -4,
      3,
      4,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-13",
      5,
      -3,
      -3,
      1,
      2,
      -1,
      -4,
      2,
      0,
      -5,
      4,
      3,
      -4,
      -2,
      -5,
      1,
      -3,
      0,
      4,
      -2,
      4,
      2,
      -5,
      1,
      -1,
      -4,
      -2,
      -1,
      1,
      -1,
      4,
      3,
      4,
      5,
      1,
      3,
      -3,
      -2,
      0,
      0,
      3,
      1,
      2,
      1,
      -1,
      2,
      3,
      0,
      5,
      0,
      -4,
      -1,
      -1,
      0,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-14",
      5,
      -3,
      -3,
      1,
      2,
      4,
      -5,
      1,
      1,
      -1,
      -4,
      2,
      1,
      1,
      3,
      3,
      0,
      3,
      -3,
      -2,
      -4,
      5,
      2,
      -1,
      0,
      -2,
      -3,
      4,
      0,
      1,
      4,
      3,
      -1,
      1,
      3,
      4,
      -5,
      2,
      2,
      -1,
      -2,
      -2,
      -4,
      -5,
      -1,
      4,
      0,
      0,
      5,
      0,
      -4,
      -1,
      -1,
      0,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-15",
      5,
      -3,
      -3,
      1,
      2,
      4,
      -4,
      1,
      0,
      0,
      1,
      1,
      3,
      -2,
      1,
      3,
      -2,
      0,
      4,
      3,
      2,
      1,
      -5,
      2,
      -1,
      3,
      1,
      -5,
      4,
      -1,
      -2,
      -1,
      0,
      -3,
      2,
      -1,
      5,
      2,
      4,
      -4,
      -1,
      -2,
      -3,
      4,
      3,
      0,
      -4,
      -5,
      5,
      0,
      -4,
      -1,
      -1,
      0,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-16",
      -2,
      0,
      3,
      -1,
      -1,
      -4,
      -3,
      2,
      2,
      0,
      -5,
      4,
      5,
      4,
      4,
      4,
      -5,
      -1,
      1,
      -2,
      -3,
      -5,
      4,
      1,
      1,
      2,
      5,
      1,
      -2,
      -3,
      -4,
      3,
      -4,
      -1,
      1,
      3,
      -3,
      -2,
      0,
      0,
      3,
      1,
      2,
      1,
      -1,
      2,
      3,
      0,
      5,
      0,
      -4,
      -1,
      -1,
      0,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-17",
      5,
      -3,
      -3,
      1,
      2,
      4,
      -5,
      -5,
      -4,
      4,
      3,
      1,
      -4,
      1,
      0,
      0,
      1,
      -1,
      -2,
      3,
      -3,
      -5,
      1,
      -4,
      0,
      -2,
      -1,
      5,
      -3,
      -1,
      -1,
      0,
      -1,
      0,
      -2,
      -2,
      2,
      5,
      1,
      4,
      4,
      3,
      -4,
      0,
      4,
      2,
      2,
      2,
      3,
      1,
      3,
      -1,
      -1,
      0,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-18",
      5,
      -3,
      -3,
      1,
      2,
      4,
      -5,
      -5,
      -4,
      2,
      -4,
      3,
      -4,
      -1,
      -3,
      -3,
      0,
      3,
      1,
      2,
      0,
      -5,
      -1,
      3,
      1,
      -1,
      0,
      4,
      4,
      1,
      4,
      4,
      3,
      -2,
      -2,
      1,
      5,
      -2,
      0,
      -2,
      -1,
      1,
      2,
      1,
      -1,
      2,
      3,
      0,
      5,
      0,
      -4,
      -1,
      -1,
      0,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-19",
      5,
      -3,
      -3,
      1,
      2,
      4,
      -5,
      -5,
      -4,
      2,
      3,
      -4,
      4,
      3,
      -1,
      -2,
      -1,
      4,
      -2,
      5,
      1,
      -5,
      1,
      4,
      -3,
      -2,
      1,
      -1,
      0,
      -4,
      -1,
      4,
      0,
      1,
      2,
      3,
      -3,
      -2,
      0,
      0,
      3,
      1,
      2,
      1,
      -1,
      2,
      3,
      0,
      5,
      0,
      -4,
      -1,
      -1,
      0,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-20",
      5,
      -3,
      -3,
      1,
      2,
      4,
      -5,
      -5,
      -4,
      2,
      -5,
      -1,
      -2,
      -2,
      5,
      -1,
      0,
      0,
      1,
      1,
      4,
      1,
      -1,
      -3,
      4,
      4,
      3,
      -2,
      2,
      4,
      -4,
      3,
      -4,
      -1,
      1,
      3,
      -3,
      -2,
      0,
      0,
      3,
      1,
      2,
      1,
      -1,
      2,
      3,
      0,
      5,
      0,
      -4,
      -1,
      -1,
      0,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-21",
      5,
      -3,
      -3,
      1,
      2,
      4,
      -5,
      -5,
      1,
      -1,
      -4,
      4,
      0,
      5,
      -2,
      -1,
      -5,
      2,
      1,
      0,
      -2,
      1,
      -1,
      -3,
      4,
      4,
      3,
      -2,
      2,
      4,
      -4,
      3,
      -4,
      -1,
      1,
      3,
      -3,
      -2,
      0,
      0,
      3,
      1,
      2,
      1,
      -1,
      2,
      3,
      0,
      5,
      0,
      -4,
      -1,
      -1,
      0,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-22",
      5,
      -3,
      -3,
      -4,
      5,
      4,
      1,
      2,
      0,
      -4,
      -1,
      5,
      4,
      -4,
      3,
      0,
      -2,
      0,
      4,
      0,
      -1,
      2,
      4,
      4,
      0,
      3,
      -2,
      1,
      -4,
      -2,
      -3,
      -1,
      -1,
      -2,
      3,
      -4,
      -5,
      -5,
      1,
      -2,
      -1,
      1,
      2,
      -5,
      1,
      2,
      0,
      0,
      3,
      1,
      -3,
      3,
      -1,
      -1,
      2,
      1,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-23",
      3,
      4,
      -1,
      -1,
      0,
      4,
      1,
      -5,
      2,
      2,
      -3,
      -5,
      -3,
      0,
      -1,
      5,
      -3,
      5,
      0,
      -1,
      -4,
      -5,
      0,
      2,
      3,
      1,
      -4,
      4,
      0,
      -3,
      -2,
      0,
      3,
      1,
      -3,
      5,
      -2,
      0,
      0,
      4,
      -5,
      5,
      3,
      -1,
      2,
      -4,
      1,
      -2,
      1,
      2,
      1,
      -1,
      -2,
      3,
      4,
      -1,
      1,
      -4,
      -2,
      -4,
    ],
    [
      "res-24",
      5,
      -3,
      -3,
      1,
      2,
      4,
      -5,
      -5,
      -4,
      2,
      -5,
      -1,
      -2,
      -2,
      5,
      -1,
      0,
      1,
      -3,
      4,
      -1,
      1,
      4,
      3,
      4,
      1,
      0,
      -2,
      2,
      4,
      -4,
      3,
      -4,
      -1,
      1,
      3,
      -3,
      -2,
      0,
      0,
      3,
      1,
      2,
      1,
      -1,
      2,
      3,
      0,
      5,
      0,
      -4,
      -1,
      -1,
      0,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-25",
      -4,
      1,
      -2,
      4,
      4,
      3,
      -1,
      -5,
      3,
      4,
      2,
      1,
      -1,
      5,
      -1,
      -1,
      2,
      -2,
      3,
      -3,
      5,
      -5,
      1,
      1,
      -2,
      -3,
      -4,
      -4,
      0,
      1,
      4,
      5,
      2,
      2,
      0,
      -3,
      3,
      0,
      3,
      -5,
      1,
      1,
      -2,
      -4,
      0,
      -3,
      -1,
      2,
      -3,
      -1,
      4,
      0,
      -1,
      -4,
      0,
      0,
      -2,
      -5,
      0,
      5,
    ],
    [
      "res-26",
      5,
      -3,
      -3,
      1,
      2,
      4,
      -5,
      -5,
      -4,
      2,
      -5,
      -1,
      -2,
      -2,
      5,
      -1,
      0,
      4,
      -1,
      1,
      0,
      1,
      1,
      -3,
      4,
      4,
      3,
      -2,
      2,
      4,
      -4,
      3,
      -4,
      -1,
      1,
      3,
      -3,
      -2,
      0,
      0,
      3,
      1,
      2,
      1,
      -1,
      2,
      3,
      0,
      5,
      0,
      -4,
      -1,
      -1,
      0,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-27",
      5,
      -3,
      -3,
      1,
      2,
      4,
      -5,
      -5,
      -4,
      2,
      -5,
      -1,
      -2,
      -2,
      5,
      -1,
      0,
      0,
      1,
      1,
      4,
      1,
      -1,
      -3,
      4,
      4,
      3,
      -2,
      2,
      4,
      -4,
      3,
      -4,
      -1,
      1,
      3,
      -3,
      -2,
      0,
      0,
      3,
      1,
      2,
      1,
      -1,
      2,
      3,
      0,
      5,
      0,
      -4,
      -1,
      -1,
      0,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-28",
      5,
      -3,
      -3,
      1,
      2,
      -5,
      2,
      0,
      4,
      -1,
      -4,
      -1,
      3,
      -3,
      4,
      0,
      2,
      4,
      1,
      4,
      -2,
      4,
      1,
      1,
      1,
      -5,
      -2,
      -4,
      -5,
      -2,
      3,
      -1,
      -4,
      5,
      -1,
      3,
      -3,
      -2,
      0,
      0,
      3,
      1,
      2,
      1,
      -1,
      2,
      3,
      0,
      5,
      0,
      -4,
      -1,
      -1,
      0,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-29",
      5,
      -3,
      -3,
      1,
      2,
      4,
      -5,
      -5,
      -4,
      2,
      -5,
      -1,
      -2,
      -2,
      5,
      -1,
      0,
      0,
      1,
      1,
      4,
      1,
      -1,
      -3,
      4,
      4,
      -2,
      2,
      3,
      -4,
      4,
      3,
      -4,
      -1,
      1,
      3,
      -3,
      -2,
      0,
      0,
      3,
      1,
      2,
      1,
      -1,
      2,
      3,
      0,
      5,
      0,
      -4,
      -1,
      -1,
      0,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-30",
      5,
      4,
      0,
      1,
      2,
      -5,
      1,
      4,
      4,
      4,
      -3,
      5,
      0,
      -3,
      -2,
      -3,
      3,
      -1,
      2,
      -2,
      1,
      -4,
      -1,
      2,
      -4,
      -5,
      -4,
      -1,
      -5,
      -1,
      3,
      1,
      1,
      -2,
      4,
      3,
      -3,
      -2,
      0,
      0,
      3,
      1,
      2,
      1,
      -1,
      2,
      3,
      0,
      5,
      0,
      -4,
      -1,
      -1,
      0,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-31",
      5,
      -3,
      -3,
      1,
      2,
      4,
      -5,
      -5,
      -4,
      2,
      -5,
      -1,
      -2,
      -2,
      5,
      -1,
      0,
      0,
      1,
      1,
      4,
      1,
      -1,
      -3,
      4,
      4,
      3,
      -2,
      2,
      4,
      -4,
      3,
      -4,
      -1,
      1,
      3,
      -3,
      -2,
      0,
      0,
      3,
      1,
      2,
      1,
      -1,
      2,
      3,
      0,
      5,
      0,
      -4,
      -1,
      -1,
      0,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-32",
      5,
      -3,
      -3,
      1,
      2,
      4,
      -5,
      -5,
      0,
      -1,
      5,
      4,
      -1,
      4,
      -2,
      2,
      -2,
      -5,
      1,
      4,
      -1,
      1,
      0,
      -2,
      -1,
      -3,
      -3,
      0,
      3,
      -4,
      1,
      -4,
      1,
      0,
      3,
      -2,
      0,
      4,
      5,
      0,
      2,
      2,
      -4,
      3,
      3,
      -1,
      1,
      3,
      2,
      1,
      -4,
      -1,
      -1,
      0,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-33",
      5,
      0,
      -2,
      5,
      -2,
      -2,
      -1,
      -5,
      1,
      4,
      1,
      2,
      -4,
      3,
      -1,
      4,
      4,
      4,
      -3,
      1,
      -4,
      2,
      -3,
      -3,
      -5,
      -1,
      -5,
      0,
      1,
      2,
      4,
      3,
      -4,
      -1,
      1,
      3,
      -3,
      -2,
      0,
      0,
      3,
      1,
      2,
      1,
      -1,
      2,
      3,
      0,
      5,
      0,
      -4,
      -1,
      -1,
      0,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-34",
      5,
      -3,
      -3,
      1,
      2,
      4,
      -5,
      -5,
      -4,
      2,
      -5,
      -1,
      -2,
      -2,
      5,
      -1,
      0,
      0,
      1,
      1,
      4,
      1,
      -1,
      -3,
      4,
      4,
      3,
      2,
      4,
      -2,
      -4,
      3,
      -4,
      -1,
      1,
      3,
      -3,
      -2,
      0,
      0,
      3,
      1,
      2,
      1,
      -1,
      2,
      3,
      0,
      5,
      0,
      -4,
      -1,
      -1,
      0,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-35",
      5,
      -3,
      -3,
      1,
      -5,
      4,
      2,
      0,
      -1,
      3,
      -5,
      -2,
      -4,
      -3,
      0,
      -2,
      0,
      1,
      -3,
      -2,
      -2,
      -4,
      4,
      3,
      5,
      1,
      -1,
      4,
      4,
      -1,
      1,
      1,
      -4,
      2,
      -5,
      3,
      -1,
      2,
      4,
      0,
      3,
      1,
      2,
      1,
      -1,
      2,
      3,
      0,
      5,
      0,
      -4,
      -1,
      -1,
      0,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-36",
      5,
      -3,
      -3,
      1,
      2,
      4,
      -5,
      -5,
      -4,
      2,
      -5,
      -1,
      -2,
      -2,
      0,
      0,
      -1,
      5,
      1,
      1,
      4,
      1,
      -1,
      -3,
      4,
      4,
      3,
      -2,
      2,
      4,
      -4,
      3,
      -4,
      -1,
      1,
      3,
      -3,
      -2,
      0,
      0,
      3,
      1,
      2,
      1,
      -1,
      2,
      3,
      0,
      5,
      0,
      -4,
      -1,
      -1,
      0,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-37",
      5,
      -3,
      -3,
      1,
      2,
      4,
      -5,
      -5,
      -4,
      2,
      -5,
      -1,
      -2,
      -2,
      5,
      4,
      1,
      -1,
      -1,
      1,
      0,
      -3,
      0,
      1,
      4,
      4,
      3,
      -2,
      2,
      4,
      -4,
      3,
      -4,
      -1,
      1,
      3,
      -3,
      -2,
      0,
      0,
      3,
      1,
      2,
      1,
      -1,
      2,
      3,
      0,
      5,
      0,
      -4,
      -1,
      -1,
      0,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-38",
      5,
      -3,
      -3,
      1,
      2,
      4,
      0,
      -3,
      2,
      -4,
      3,
      4,
      1,
      3,
      -5,
      -2,
      -5,
      0,
      -2,
      2,
      -1,
      1,
      1,
      3,
      -1,
      1,
      -1,
      -2,
      -4,
      0,
      -5,
      -1,
      -3,
      -4,
      0,
      4,
      1,
      0,
      5,
      3,
      4,
      2,
      0,
      -1,
      3,
      -2,
      -4,
      0,
      2,
      -1,
      5,
      4,
      1,
      -4,
      -1,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-39",
      5,
      -3,
      -3,
      1,
      2,
      4,
      4,
      4,
      -5,
      -4,
      -3,
      3,
      4,
      -1,
      4,
      2,
      0,
      2,
      -5,
      -2,
      -4,
      3,
      -2,
      1,
      -1,
      -4,
      1,
      -2,
      -5,
      0,
      -1,
      5,
      1,
      -1,
      1,
      3,
      -3,
      -2,
      0,
      0,
      3,
      1,
      2,
      1,
      -1,
      2,
      3,
      0,
      5,
      0,
      -4,
      -1,
      -1,
      0,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-40",
      5,
      -5,
      2,
      -2,
      2,
      4,
      -3,
      3,
      0,
      -4,
      -1,
      -5,
      5,
      4,
      1,
      -5,
      -3,
      -2,
      -3,
      2,
      3,
      -1,
      -3,
      0,
      4,
      -2,
      -2,
      -4,
      4,
      -4,
      1,
      1,
      3,
      0,
      3,
      -1,
      1,
      4,
      -1,
      0,
      1,
      1,
      2,
      1,
      -1,
      2,
      3,
      0,
      5,
      0,
      -4,
      -1,
      -1,
      0,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-41",
      5,
      -3,
      -3,
      1,
      2,
      4,
      -5,
      -5,
      -4,
      3,
      0,
      -1,
      -4,
      -2,
      -1,
      -4,
      1,
      -2,
      4,
      1,
      4,
      5,
      -2,
      2,
      1,
      3,
      -1,
      -1,
      4,
      2,
      4,
      0,
      -5,
      -3,
      1,
      3,
      -3,
      -2,
      0,
      0,
      3,
      1,
      2,
      1,
      -1,
      2,
      3,
      0,
      5,
      0,
      -4,
      -1,
      -1,
      0,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-42",
      5,
      -3,
      -3,
      1,
      2,
      4,
      -5,
      -5,
      -4,
      2,
      -5,
      -1,
      -2,
      -2,
      5,
      -1,
      0,
      0,
      1,
      1,
      4,
      1,
      -1,
      -3,
      4,
      4,
      3,
      -2,
      2,
      4,
      -4,
      3,
      -4,
      -1,
      1,
      3,
      -3,
      -2,
      0,
      0,
      3,
      1,
      2,
      1,
      -1,
      2,
      3,
      0,
      5,
      0,
      -4,
      -1,
      -1,
      0,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-43",
      5,
      -3,
      -3,
      1,
      2,
      4,
      -5,
      -5,
      -4,
      2,
      -5,
      -1,
      -2,
      -2,
      5,
      -1,
      0,
      0,
      2,
      4,
      -1,
      4,
      -2,
      1,
      4,
      -3,
      3,
      3,
      -1,
      4,
      1,
      1,
      -4,
      -4,
      1,
      3,
      -3,
      -2,
      0,
      0,
      3,
      1,
      2,
      1,
      -1,
      2,
      3,
      0,
      5,
      0,
      -4,
      -1,
      -1,
      0,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-44",
      5,
      -3,
      -4,
      -3,
      -1,
      0,
      -1,
      1,
      1,
      4,
      2,
      -2,
      -1,
      5,
      -2,
      2,
      0,
      4,
      -5,
      -5,
      1,
      -3,
      1,
      -5,
      4,
      4,
      3,
      -2,
      2,
      4,
      -4,
      3,
      -4,
      -1,
      1,
      3,
      -3,
      -2,
      0,
      0,
      3,
      1,
      2,
      1,
      -1,
      2,
      3,
      0,
      5,
      0,
      -4,
      -1,
      -1,
      0,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-45",
      5,
      -3,
      -3,
      1,
      2,
      4,
      -5,
      -5,
      -4,
      2,
      -5,
      -1,
      -2,
      -2,
      5,
      -1,
      0,
      0,
      1,
      1,
      4,
      1,
      -1,
      -3,
      3,
      4,
      -2,
      -1,
      4,
      1,
      2,
      -4,
      3,
      3,
      -4,
      4,
      -3,
      -2,
      0,
      0,
      3,
      1,
      2,
      1,
      -1,
      2,
      3,
      0,
      5,
      0,
      -4,
      -1,
      -1,
      0,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-46",
      5,
      -3,
      -3,
      1,
      2,
      4,
      -5,
      -5,
      -4,
      2,
      -5,
      3,
      -1,
      3,
      3,
      1,
      3,
      2,
      1,
      -1,
      -2,
      1,
      4,
      1,
      2,
      0,
      1,
      0,
      -2,
      5,
      -4,
      4,
      4,
      1,
      0,
      -1,
      -4,
      -3,
      -2,
      -1,
      4,
      -2,
      -3,
      0,
      -1,
      2,
      3,
      0,
      5,
      0,
      -4,
      -1,
      -1,
      0,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-47",
      5,
      0,
      0,
      -4,
      -5,
      -5,
      2,
      1,
      -3,
      -1,
      -4,
      1,
      3,
      3,
      2,
      -1,
      -4,
      4,
      3,
      -2,
      3,
      -2,
      -2,
      1,
      4,
      1,
      0,
      -1,
      -4,
      0,
      -5,
      -2,
      5,
      0,
      -1,
      3,
      -3,
      -1,
      1,
      4,
      -3,
      -3,
      4,
      -1,
      1,
      -2,
      0,
      -4,
      0,
      -5,
      -1,
      5,
      1,
      0,
      -3,
      2,
      2,
      4,
      2,
      5,
    ],
    [
      "res-48",
      5,
      -3,
      -3,
      1,
      2,
      4,
      -5,
      -5,
      -4,
      -1,
      -1,
      -5,
      4,
      0,
      1,
      -2,
      1,
      5,
      -2,
      2,
      0,
      1,
      -1,
      -3,
      4,
      4,
      3,
      -2,
      2,
      4,
      -4,
      3,
      -4,
      -1,
      1,
      3,
      -3,
      -2,
      0,
      0,
      3,
      1,
      2,
      1,
      -1,
      2,
      3,
      0,
      5,
      0,
      -4,
      -1,
      -1,
      0,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-49",
      5,
      1,
      2,
      2,
      0,
      -2,
      3,
      4,
      -1,
      1,
      4,
      -2,
      -2,
      -1,
      -1,
      4,
      -3,
      1,
      -1,
      0,
      0,
      -5,
      5,
      0,
      5,
      2,
      -4,
      -3,
      3,
      1,
      -3,
      -1,
      3,
      3,
      0,
      4,
      2,
      1,
      1,
      -5,
      -5,
      4,
      3,
      -2,
      -4,
      2,
      1,
      -3,
      -4,
      0,
      -4,
      -1,
      -1,
      0,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-50",
      5,
      -3,
      -3,
      1,
      2,
      -1,
      3,
      1,
      1,
      0,
      0,
      2,
      2,
      4,
      5,
      -4,
      0,
      -1,
      1,
      2,
      -5,
      3,
      -2,
      5,
      4,
      -2,
      -1,
      -1,
      0,
      4,
      -2,
      -5,
      3,
      3,
      1,
      -1,
      -4,
      -4,
      -3,
      0,
      2,
      -2,
      -1,
      4,
      4,
      1,
      -1,
      0,
      -5,
      3,
      1,
      -3,
      -4,
      0,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-51",
      5,
      -3,
      -3,
      1,
      2,
      -4,
      -5,
      -1,
      2,
      -2,
      -5,
      -5,
      5,
      4,
      1,
      0,
      -2,
      0,
      -1,
      1,
      4,
      1,
      -1,
      -3,
      4,
      4,
      3,
      -2,
      2,
      4,
      -4,
      3,
      -4,
      -1,
      1,
      3,
      -3,
      -2,
      0,
      0,
      3,
      1,
      2,
      1,
      -1,
      2,
      3,
      0,
      5,
      0,
      -4,
      -1,
      -1,
      0,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-52",
      5,
      -3,
      -3,
      1,
      2,
      4,
      -5,
      -5,
      -4,
      2,
      -5,
      -1,
      -2,
      -2,
      5,
      -1,
      0,
      0,
      1,
      1,
      4,
      1,
      -1,
      -3,
      4,
      4,
      3,
      2,
      -2,
      4,
      -4,
      3,
      -4,
      -1,
      1,
      3,
      -3,
      -2,
      0,
      0,
      3,
      1,
      2,
      1,
      -1,
      2,
      3,
      0,
      5,
      0,
      -4,
      -1,
      -1,
      0,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-53",
      5,
      5,
      1,
      4,
      -5,
      0,
      4,
      1,
      4,
      4,
      -2,
      5,
      0,
      2,
      3,
      3,
      4,
      -1,
      -3,
      1,
      2,
      -2,
      -1,
      -3,
      -3,
      0,
      2,
      1,
      -5,
      1,
      3,
      -5,
      -2,
      0,
      1,
      -1,
      2,
      -1,
      3,
      1,
      -3,
      0,
      0,
      3,
      -4,
      -1,
      2,
      -4,
      -4,
      -1,
      -4,
      -2,
      -1,
      0,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-54",
      5,
      -3,
      -3,
      1,
      2,
      4,
      -5,
      -5,
      -4,
      2,
      -5,
      -1,
      -2,
      -2,
      5,
      -1,
      0,
      0,
      1,
      1,
      4,
      1,
      -1,
      -3,
      4,
      4,
      3,
      -4,
      4,
      2,
      -4,
      -2,
      3,
      -1,
      1,
      3,
      -3,
      -2,
      0,
      0,
      3,
      1,
      2,
      1,
      -1,
      2,
      3,
      0,
      5,
      0,
      -4,
      -1,
      -1,
      0,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-55",
      5,
      -3,
      -3,
      1,
      2,
      4,
      -5,
      -5,
      -4,
      2,
      -5,
      -1,
      -2,
      -2,
      5,
      -1,
      0,
      0,
      1,
      1,
      4,
      1,
      -1,
      -3,
      4,
      4,
      3,
      -2,
      2,
      4,
      -4,
      3,
      -4,
      -1,
      1,
      3,
      -3,
      -2,
      0,
      0,
      3,
      1,
      2,
      1,
      -1,
      2,
      3,
      0,
      5,
      0,
      -4,
      -1,
      -1,
      0,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-56",
      5,
      -1,
      1,
      3,
      1,
      -1,
      4,
      5,
      -2,
      2,
      4,
      -3,
      -3,
      -5,
      0,
      0,
      -5,
      -3,
      -4,
      -2,
      -1,
      1,
      -5,
      4,
      1,
      4,
      2,
      -2,
      2,
      4,
      -4,
      3,
      -4,
      -1,
      1,
      3,
      -3,
      -2,
      0,
      0,
      3,
      1,
      2,
      1,
      -1,
      2,
      3,
      0,
      5,
      0,
      -4,
      -1,
      -1,
      0,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-57",
      5,
      -3,
      -3,
      -2,
      -3,
      1,
      0,
      -4,
      -5,
      0,
      1,
      -5,
      3,
      -1,
      4,
      4,
      5,
      -2,
      -4,
      4,
      -1,
      -2,
      4,
      2,
      -1,
      -5,
      2,
      2,
      1,
      4,
      1,
      3,
      -4,
      -1,
      1,
      3,
      -3,
      -2,
      0,
      0,
      3,
      1,
      2,
      1,
      -1,
      2,
      3,
      0,
      5,
      0,
      -4,
      -1,
      -1,
      0,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-58",
      5,
      -3,
      -3,
      1,
      2,
      4,
      -5,
      -5,
      -4,
      2,
      -5,
      -1,
      -2,
      -2,
      5,
      -1,
      0,
      0,
      1,
      1,
      4,
      1,
      -1,
      -3,
      4,
      4,
      3,
      -2,
      2,
      4,
      -4,
      3,
      -4,
      -1,
      1,
      3,
      -3,
      -2,
      0,
      0,
      3,
      1,
      2,
      1,
      -1,
      2,
      3,
      0,
      5,
      0,
      -4,
      -1,
      -1,
      0,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-59",
      5,
      1,
      1,
      4,
      -4,
      4,
      3,
      -3,
      0,
      3,
      1,
      1,
      -4,
      2,
      -4,
      -3,
      -5,
      -5,
      -1,
      2,
      0,
      -2,
      -4,
      -5,
      4,
      2,
      0,
      3,
      3,
      -4,
      -2,
      0,
      -3,
      -3,
      -1,
      0,
      -3,
      -5,
      4,
      4,
      -2,
      1,
      5,
      -1,
      -1,
      -2,
      3,
      -2,
      1,
      2,
      0,
      5,
      -1,
      -1,
      0,
      -1,
      1,
      2,
      0,
      5,
    ],
    [
      "res-60",
      5,
      -3,
      -3,
      1,
      2,
      4,
      -5,
      -5,
      -4,
      2,
      -5,
      -1,
      -2,
      -2,
      5,
      -1,
      0,
      0,
      1,
      1,
      4,
      1,
      -1,
      -3,
      4,
      4,
      3,
      -2,
      2,
      4,
      -4,
      3,
      -4,
      -1,
      1,
      3,
      -3,
      -2,
      0,
      0,
      3,
      1,
      2,
      1,
      -1,
      2,
      3,
      0,
      5,
      0,
      -4,
      -1,
      -1,
      0,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-61",
      5,
      -3,
      -3,
      1,
      2,
      4,
      -5,
      -5,
      -4,
      2,
      -5,
      -1,
      1,
      -2,
      1,
      0,
      -1,
      -2,
      5,
      1,
      4,
      0,
      -1,
      -3,
      4,
      4,
      3,
      -2,
      2,
      4,
      -4,
      3,
      -4,
      -1,
      1,
      3,
      -3,
      -2,
      0,
      0,
      3,
      1,
      2,
      1,
      -1,
      2,
      3,
      0,
      5,
      0,
      -4,
      -1,
      -1,
      0,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-62",
      5,
      0,
      5,
      -2,
      3,
      -5,
      -2,
      4,
      3,
      4,
      -1,
      3,
      1,
      2,
      5,
      0,
      -1,
      -3,
      -1,
      -4,
      -5,
      -4,
      0,
      0,
      1,
      -3,
      -1,
      1,
      1,
      -4,
      2,
      4,
      4,
      -1,
      -5,
      3,
      -3,
      0,
      -1,
      0,
      1,
      -3,
      0,
      -1,
      1,
      2,
      3,
      4,
      -2,
      -2,
      2,
      2,
      -4,
      1,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-63",
      5,
      -3,
      -3,
      1,
      -5,
      -2,
      -4,
      2,
      0,
      5,
      -1,
      -5,
      2,
      -1,
      -5,
      -2,
      4,
      0,
      1,
      1,
      4,
      1,
      -1,
      -3,
      4,
      4,
      3,
      -2,
      2,
      4,
      -4,
      3,
      -4,
      -1,
      1,
      3,
      -3,
      -2,
      0,
      0,
      3,
      1,
      2,
      1,
      -1,
      2,
      3,
      0,
      5,
      0,
      -4,
      -1,
      -1,
      0,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-64",
      5,
      -3,
      -3,
      -1,
      -1,
      4,
      0,
      -2,
      5,
      4,
      2,
      1,
      -4,
      -5,
      -1,
      2,
      3,
      4,
      -5,
      1,
      0,
      2,
      1,
      -5,
      4,
      -2,
      -3,
      4,
      -2,
      1,
      -4,
      3,
      -4,
      -1,
      1,
      3,
      -3,
      -2,
      0,
      0,
      3,
      1,
      2,
      1,
      -1,
      2,
      3,
      0,
      5,
      0,
      -4,
      -1,
      -1,
      0,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-65",
      2,
      -2,
      -3,
      0,
      5,
      0,
      1,
      3,
      -3,
      -5,
      -3,
      2,
      0,
      1,
      4,
      5,
      -5,
      -2,
      3,
      0,
      -1,
      -1,
      -4,
      0,
      0,
      4,
      4,
      -1,
      -2,
      2,
      -1,
      5,
      0,
      -1,
      3,
      -4,
      -1,
      3,
      1,
      -4,
      4,
      -1,
      -4,
      1,
      -3,
      -4,
      -2,
      2,
      4,
      1,
      1,
      -2,
      3,
      2,
      -5,
      1,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-66",
      5,
      -3,
      -3,
      1,
      2,
      4,
      -5,
      -5,
      -4,
      -2,
      2,
      -2,
      0,
      -1,
      4,
      1,
      4,
      5,
      1,
      -5,
      -1,
      1,
      -3,
      0,
      4,
      -1,
      3,
      -2,
      2,
      4,
      -4,
      3,
      -4,
      -1,
      1,
      3,
      -3,
      -2,
      0,
      0,
      3,
      1,
      2,
      1,
      -1,
      2,
      3,
      0,
      5,
      0,
      -4,
      -1,
      -1,
      0,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-67",
      5,
      -3,
      -3,
      1,
      2,
      4,
      -1,
      1,
      4,
      -1,
      1,
      -4,
      -2,
      5,
      -5,
      -4,
      5,
      3,
      -5,
      -5,
      2,
      3,
      3,
      -1,
      0,
      2,
      4,
      -2,
      -1,
      -4,
      -1,
      3,
      0,
      -2,
      2,
      0,
      2,
      -4,
      -3,
      -2,
      0,
      0,
      -1,
      4,
      -3,
      4,
      -1,
      0,
      1,
      1,
      0,
      3,
      1,
      1,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-68",
      5,
      -3,
      -3,
      1,
      2,
      4,
      -5,
      -5,
      -4,
      2,
      -5,
      -1,
      -2,
      -2,
      5,
      -3,
      0,
      2,
      -3,
      -1,
      4,
      4,
      -1,
      -4,
      1,
      1,
      0,
      -2,
      4,
      -4,
      0,
      3,
      0,
      3,
      -1,
      1,
      -2,
      4,
      1,
      3,
      3,
      1,
      2,
      1,
      -1,
      2,
      3,
      0,
      5,
      0,
      -4,
      -1,
      -1,
      0,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-69",
      5,
      -3,
      -3,
      1,
      2,
      4,
      -5,
      -5,
      -4,
      2,
      -5,
      -1,
      -2,
      -2,
      5,
      -1,
      0,
      0,
      1,
      1,
      4,
      1,
      -1,
      -3,
      4,
      4,
      3,
      -2,
      2,
      4,
      -4,
      3,
      -4,
      -1,
      1,
      3,
      -3,
      -2,
      0,
      0,
      3,
      1,
      2,
      1,
      -1,
      2,
      3,
      0,
      5,
      0,
      -4,
      -1,
      -1,
      0,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-70",
      5,
      -3,
      -3,
      1,
      2,
      4,
      -5,
      -5,
      -4,
      2,
      -5,
      -1,
      -2,
      5,
      3,
      -1,
      4,
      1,
      4,
      0,
      -1,
      4,
      1,
      1,
      -2,
      -3,
      -2,
      2,
      0,
      4,
      -4,
      3,
      -4,
      -1,
      1,
      3,
      -3,
      -2,
      0,
      0,
      3,
      1,
      2,
      1,
      -1,
      2,
      3,
      0,
      5,
      0,
      -4,
      -1,
      -1,
      0,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-71",
      5,
      -3,
      -3,
      1,
      2,
      4,
      -5,
      -5,
      -4,
      2,
      -5,
      -1,
      -2,
      -2,
      5,
      -1,
      0,
      0,
      1,
      1,
      4,
      4,
      4,
      4,
      2,
      3,
      -1,
      -3,
      -2,
      1,
      -4,
      3,
      -4,
      -1,
      1,
      3,
      -3,
      -2,
      0,
      0,
      3,
      1,
      2,
      1,
      -1,
      2,
      3,
      0,
      5,
      0,
      -4,
      -1,
      -1,
      0,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-72",
      5,
      -3,
      -3,
      1,
      2,
      4,
      -5,
      -5,
      -4,
      2,
      -5,
      -1,
      -2,
      -2,
      5,
      3,
      -1,
      -2,
      3,
      1,
      1,
      -4,
      2,
      1,
      0,
      -3,
      -3,
      -2,
      2,
      0,
      3,
      1,
      1,
      -1,
      1,
      4,
      0,
      3,
      -1,
      0,
      4,
      -4,
      4,
      4,
      -1,
      2,
      3,
      0,
      5,
      0,
      -4,
      -1,
      -1,
      0,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-73",
      5,
      -3,
      -3,
      1,
      2,
      4,
      -5,
      -3,
      -1,
      1,
      3,
      -2,
      5,
      -5,
      4,
      -1,
      4,
      3,
      2,
      2,
      1,
      -2,
      0,
      0,
      -4,
      1,
      1,
      -4,
      3,
      2,
      -5,
      -4,
      3,
      -1,
      0,
      -3,
      -1,
      2,
      1,
      4,
      1,
      -2,
      3,
      -2,
      -1,
      4,
      0,
      0,
      5,
      0,
      -4,
      -1,
      -1,
      0,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-74",
      5,
      -3,
      -3,
      1,
      2,
      4,
      -5,
      -5,
      -4,
      2,
      -5,
      -1,
      -2,
      -2,
      5,
      -1,
      0,
      0,
      1,
      1,
      4,
      1,
      -1,
      -3,
      4,
      4,
      3,
      -2,
      2,
      4,
      -4,
      3,
      -4,
      -1,
      1,
      3,
      -3,
      -2,
      0,
      0,
      3,
      1,
      2,
      1,
      -1,
      2,
      3,
      0,
      5,
      0,
      -4,
      -1,
      -1,
      0,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-75",
      5,
      -3,
      -3,
      1,
      2,
      2,
      -2,
      -4,
      3,
      1,
      -1,
      -2,
      4,
      -3,
      2,
      1,
      0,
      -1,
      -1,
      1,
      0,
      4,
      1,
      4,
      -5,
      -4,
      -2,
      -1,
      -3,
      5,
      -1,
      -2,
      5,
      2,
      3,
      0,
      0,
      4,
      -1,
      0,
      -4,
      0,
      3,
      1,
      1,
      3,
      -4,
      -1,
      -5,
      -5,
      2,
      3,
      4,
      0,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-76",
      5,
      -3,
      -3,
      1,
      2,
      4,
      -5,
      -5,
      -4,
      2,
      -5,
      -1,
      -2,
      -2,
      5,
      -1,
      0,
      0,
      1,
      1,
      4,
      1,
      -1,
      -3,
      4,
      4,
      3,
      -2,
      2,
      4,
      -4,
      3,
      -4,
      -1,
      1,
      3,
      -3,
      -2,
      0,
      0,
      3,
      1,
      2,
      1,
      -1,
      2,
      3,
      0,
      5,
      0,
      -4,
      -1,
      -1,
      0,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-77",
      5,
      4,
      -5,
      4,
      2,
      -5,
      0,
      0,
      -4,
      1,
      -2,
      2,
      1,
      5,
      -3,
      -1,
      -1,
      1,
      -3,
      -3,
      4,
      -5,
      4,
      1,
      -1,
      -2,
      3,
      -2,
      2,
      4,
      -4,
      3,
      -4,
      -1,
      1,
      3,
      -3,
      -2,
      0,
      0,
      3,
      1,
      2,
      1,
      -1,
      2,
      3,
      0,
      5,
      0,
      -4,
      -1,
      -1,
      0,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-78",
      -1,
      3,
      -3,
      0,
      -5,
      3,
      2,
      4,
      -4,
      -5,
      -2,
      2,
      -5,
      0,
      2,
      -1,
      1,
      -5,
      2,
      4,
      -1,
      -4,
      4,
      -2,
      4,
      0,
      -1,
      -2,
      1,
      -4,
      1,
      -1,
      2,
      5,
      0,
      1,
      -3,
      -1,
      5,
      -2,
      0,
      1,
      3,
      0,
      -1,
      3,
      -3,
      3,
      -4,
      -4,
      1,
      4,
      -2,
      0,
      1,
      -3,
      5,
      0,
      -3,
      5,
    ],
    [
      "res-79",
      5,
      -3,
      -3,
      1,
      2,
      4,
      -5,
      -5,
      -4,
      2,
      -5,
      -1,
      -2,
      -2,
      5,
      -1,
      0,
      1,
      -4,
      -3,
      0,
      -2,
      -3,
      4,
      3,
      1,
      0,
      2,
      4,
      -1,
      1,
      1,
      4,
      4,
      1,
      3,
      -1,
      3,
      0,
      -4,
      3,
      2,
      -2,
      1,
      -1,
      2,
      3,
      0,
      5,
      0,
      -4,
      -1,
      -1,
      0,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
    [
      "res-80",
      5,
      -3,
      -3,
      1,
      2,
      4,
      -5,
      -5,
      -4,
      2,
      -5,
      -1,
      -2,
      -2,
      5,
      -1,
      0,
      0,
      1,
      1,
      4,
      1,
      -1,
      -3,
      4,
      4,
      3,
      -2,
      2,
      4,
      -4,
      3,
      -4,
      -1,
      1,
      3,
      -3,
      -2,
      0,
      0,
      3,
      1,
      2,
      1,
      -1,
      2,
      3,
      0,
      5,
      0,
      -4,
      -1,
      -1,
      0,
      -4,
      -2,
      -3,
      -5,
      0,
      5,
    ],
  ];

  const statements = [
    "私は、iPadがこの授業で良い学習環境作りに役立ったと思います",
    "私たちは、iPadを使用したため、私はこの授業では、より簡単に概念を学びました",
    "私は、iPadのため、私の他のクラスに比べて、このクラスの同級生からより多くを学びました",
    "iPadは、私がそうでなければ学んでなかったであろうことは、このクラスで物事を学ぶために私を助けました",
    "iPadを使用すると、それが簡単に私がクラスで使用される概念間の接続を分かるようようにしました",
    " iPadを使用することで、学習の私の好ましい方法とよく一致しました",
    "私は、このクラスで iPadを使用したため、 学ぶために私のやる気を引き出します",
    "私は、このクラスで学んだのiPadのスキルが他のクラスで私を役に立つと思います",
    "iPadを使用によって、私はもっとクラスの概念に集中することができた",
    "iPadを使用によって、前のクラスセッションからの概念を覚えて私を助けました",
    "私がiPadの使用によって、私の他のクラスよりも、このクラスではより多くに参加しました",
    "iPadのSocrativeアプリを使用したから、より簡単に授業の概念について意見を表現することができた",
    " iPadのSocrativeアプリを使用によって、他の生徒の意見を参照を見ることが面白かったです",
    "フィードバックを与えるためのiPadを使用したのは、学生のプレゼンテーションより興味深いになった",
    "Kahootのクイズは、コースの概念を学ぶために私を助けました",
    "クラスでのiPadを使用するには、私は英語で話すことがより困難になります",
    "私は授業中にソーシャルメディアアプリケーション（LINEやFacebook）にアクセスするためのiPadを使用していました",
    "このクラスでのiPadを使用して貴重な授業時間を無駄にした",
    "私はこのクラスのiPadのアプリを使用する方法を理解するのは困難でした",
    "このクラスでのiPadを使用すると、コースの概念はさらに混乱製された",
    "iPadを使って、自分の考えを表現することは困難でした",
    "アプリ関連の材料は、他のクラスの材料とよく統合されていませんでした",
    "教室の前に画面に表示される持つ私の意見は私の意見を表現するために、私はより消極製になった",
    "授業中のiPadを使用している間、私は退屈になりました",
    "iPadを使用しているとき、私は、他の学生の技術と同様に熟練していないので、私はぎこちない感じました",
    "iPadを使ったため、私はコースの概念に集中するのは、より困難になりました",
    "iPadを使ったため、教授と英語で話すことがより困難になります",
    "iPadを使ったため、他の学生と英語で話すことがより困難になります",
    " 私は理由のiPadの使用の授業中に英語を話すために私の能力にいくつかの信頼を失いました",
    "授業中のiPadを使用すると、不便でした",
    "私は、iPadがこの授業で良い学習環境作りに役立ったと思います",
    "私たちは、iPadを使用したため、私はこの授業では、より簡単に概念を学びました",
    "私は、iPadのため、私の他のクラスに比べて、このクラスの同級生からより多くを学びました",
    "iPadは、私がそうでなければ学んでなかったであろうことは、このクラスで物事を学ぶために私を助けました",
    "iPadを使用すると、それが簡単に私がクラスで使用される概念間の接続を分かるようようにしました",
    " iPadを使用することで、学習の私の好ましい方法とよく一致しました",
    "私は、このクラスで iPadを使用したため、 学ぶために私のやる気を引き出します",
    "私は、このクラスで学んだのiPadのスキルが他のクラスで私を役に立つと思います",
    "iPadを使用によって、私はもっとクラスの概念に集中することができた",
    "iPadを使用によって、前のクラスセッションからの概念を覚えて私を助けました",
    "私がiPadの使用によって、私の他のクラスよりも、このクラスではより多くに参加しました",
    "iPadのSocrativeアプリを使用したから、より簡単に授業の概念について意見を表現することができた",
    " iPadのSocrativeアプリを使用によって、他の生徒の意見を参照を見ることが面白かったです",
    "フィードバックを与えるためのiPadを使用したのは、学生のプレゼンテーションより興味深いになった",
    "Kahootのクイズは、コースの概念を学ぶために私を助けました",
    "クラスでのiPadを使用するには、私は英語で話すことがより困難になります",
    "私は授業中にソーシャルメディアアプリケーション（LINEやFacebook）にアクセスするためのiPadを使用していました",
    "このクラスでのiPadを使用して貴重な授業時間を無駄にした",
    "私はこのクラスのiPadのアプリを使用する方法を理解するのは困難でした",
    "このクラスでのiPadを使用すると、コースの概念はさらに混乱製された",
    "iPadを使って、自分の考えを表現することは困難でした",
    "アプリ関連の材料は、他のクラスの材料とよく統合されていませんでした",
    "教室の前に画面に表示される持つ私の意見は私の意見を表現するために、私はより消極製になった",
    "授業中のiPadを使用している間、私は退屈になりました",
    "iPadを使用しているとき、私は、他の学生の技術と同様に熟練していないので、私はぎこちない感じました",
    "iPadを使ったため、私はコースの概念に集中するのは、より困難になりました",
    "iPadを使ったため、教授と英語で話すことがより困難になります",
    "iPadを使ったため、他の学生と英語で話すことがより困難になります",
    " 私は理由のiPadの使用の授業中に英語を話すために私の能力にいくつかの信頼を失いました",
    "授業中のiPadを使用すると、不便でした",
  ];

  let sortsData = motivationalToArray(data, 60, -5);
  let sortsDisplayText2 = sortsDisplayText(sortsData[1]);

  const allData = {
    projectName: "iPad Survey (Japanese)",
    projectHistoryArray: ["iPad project loaded from demo data"],
    statements: statements,
    numQsorts: 80,
    numStatements: 60,
    multiplierArray: [
      0, 4, 5, 5, 5, 7, 8, 7, 5, 5, 5, 4, 0, 0, 0, 0, 0, 0, 0, 0,
    ],
    mainDataObject: sortsData[1],
    sortsDisplayText: sortsDisplayText2,
    respondentNames: sortsData[0],
    qSortPattern: [
      -5, -5, -5, -5, -4, -4, -4, -4, -4, -3, -3, -3, -3, -3, -2, -2, -2, -2,
      -2, -1, -1, -1, -1, -1, -1, -1, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1,
      1, 2, 2, 2, 2, 2, 3, 3, 3, 3, 3, 4, 4, 4, 4, 4, 5, 5, 5, 5,
    ],
    statementNumArray: [
      1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
      22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39,
      40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57,
      58, 59, 60,
    ],
  };

  return allData;
};

export default uploadJapaneseData;
